import { Controller } from "@hotwired/stimulus"

// State filters for the homepage locations carousel (R4 M1).
//
// Selecting NOTHING and selecting EVERYTHING both mean "no filter" — every resort
// shows. Anything in between shows only the checked states. The generic
// toggle_controller can't express that: it flips a class per box, so "none checked"
// there means "nothing visible" rather than "no filter applied".
export default class extends Controller {
  static targets = ["checkbox", "card"]

  apply() {
    const states = this.checkedStates
    const filtering = states.length > 0 && states.length < this.checkboxTargets.length

    this.cardTargets.forEach(card => {
      const hide = filtering && !states.includes(card.dataset.locationFilterState)
      card.classList.toggle("hidden", hide)
    })
  }

  get checkedStates() {
    return this.checkboxTargets.filter(box => box.checked).map(box => box.value)
  }
}
